module.exports = __webpack_public_path__ + "img/ssal.ab14966f.png";